import { Command } from 'commands/Commands';

export class ChangeMemberTwitterVisibility extends Command {
  type: string = 'Member.ChangeTwitterVisibility';
  priority = 100;
}
